<template>
  <b-col cols="12" class="mt-3">
    <transition name="fade-slide">
      <div v-if="isClaimListVisible">
        <div class="form-content-wrapper mb-0">
          <h6 class="form-title mb-3">Daftar Klaim Hadiah Spektakuler</h6>
        </div>

        <b-row class="mb-3">
          <b-col cols="12" md="6">
            <b-form-group label="Kode Hadiah">
              <b-form-input
                v-model="claimFilters.hadiahCode"
                placeholder="Masukkan kode hadiah"
                @keyup.enter="searchClaimList"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group label="Nama Nasabah">
              <b-form-input
                v-model="claimFilters.customerName"
                placeholder="Masukkan nama nasabah"
                @keyup.enter="searchClaimList"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group label="Cabang">
              <multiselect
                v-model="claimFilters.cabang"
                :options="cabangOptions"
                :internal-search="true"
                :allow-empty="false"
                deselect-label=""
                select-label=""
                label="name"
                track-by="id"
                placeholder="Semua"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="pgiBtn"
              class="mr-2"
              :disabled="claimListState.isBusy"
              @click="searchClaimList"
            >
              <i class="fa fa-search mr-1"></i>
              Search
            </b-button>
            <b-button
              variant="pgiBtn"
              :disabled="claimListState.isBusy"
              @click="resetClaimListFilter"
            >
              Reset
            </b-button>
          </b-col>
        </b-row>

        <b-table
          bordered
          hover
          responsive
          show-empty
          :busy="claimListState.isBusy"
          :items="claimList"
          :fields="claimFields"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Mengambil data...</strong>
            </div>
          </template>
          <template v-slot:empty>
            Tidak ada data.
          </template>
          <template v-slot:cell(nasabah)="row">
            <p class="mb-0">{{ row.item.nasabahName || '-' }}</p>
            <p class="mb-0 smallText text-muted">{{ row.item.noAnggota || '-' }}</p>
          </template>
          <template v-slot:cell(claimed)="row">
            <p class="mb-0">{{ row.item.claimedBy || '-' }}</p>
            <p class="mb-0 smallText text-muted">
              {{ $helper.changeDateFormat(row.item.claimedAt) }}
              {{ $helper.changeDateFormatGetHour(row.item.claimedAt) }}
            </p>
          </template>
          <template v-slot:cell(evidence)="row">
            <div class="d-flex flex-wrap evidence-buttons">
              <b-button
                v-if="row.item.urlPhoto"
                v-b-tooltip.hover.bottom
                title="Foto Nasabah dengan Hadiah dan Identitas"
                size="sm"
                variant="pgiBtn"
                :href="row.item.urlPhoto"
                target="_blank"
                download
              >
                <i class="fa fa-download mr-1"></i>Foto
              </b-button>
              <b-button
                v-if="row.item.urlReceipt"
                v-b-tooltip.hover.bottom
                title="Tanda Terima Penyerahan Hadiah"
                size="sm"
                variant="pgiBtn"
                :href="row.item.urlReceipt"
                target="_blank"
                download
              >
                <i class="fa fa-download mr-1"></i>Tanda Terima
              </b-button>
              <b-button
                v-if="row.item.urlVideo"
                v-b-tooltip.hover.bottom
                title="Video Testimoni"
                size="sm"
                variant="pgiBtn"
                :href="row.item.urlVideo"
                target="_blank"
                download
              >
                <i class="fa fa-download mr-1"></i>Video Testimoni
              </b-button>
            </div>
          </template>
        </b-table>

        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
          <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
            <b-form-select
              v-model="claimListState.perPage"
              :options="claimListPageOptions"
              @change="onClaimListLimitChange"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled />
              </template>
            </b-form-select>
            <span class="ml-2">{{ claimListState.totalViewText }}</span>
          </b-input-group>
          <b-pagination
            class="mb-0"
            v-model="claimListState.currentPage"
            :total-rows="claimListState.totalRows"
            :per-page="claimListState.perPage"
            @input="onClaimListPageChange"
          />
        </div>
      </div>
    </transition>

    <b-modal
      id="modal-pilih-klaim-hadiah"
      title="Klaim Hadiah Spektakuler"
      size="lg"
      no-close-on-backdrop
    >
      <b-form-group label="Input Kode Hadiah">
        <b-input-group>
          <b-form-input
            v-model="hadiahInput"
            placeholder="Masukkan kode hadiah"
            :disabled="isLoadingSearch"
            @keyup.enter="searchHadiah"
          />
          <b-input-group-append>
            <b-button
              variant="pgiBtn"
              :disabled="isLoadingSearch"
              @click="searchHadiah"
            >
              <b-spinner v-if="isLoadingSearch" small type="grow" class="mr-1" />
              <i v-else class="fa fa-search mr-1"></i>
              {{ isLoadingSearch ? 'Loading...' : 'Cari' }}
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <transition name="fade-slide">
        <div v-if="selectedHadiah" class="mt-3">
          <div class="form-content-wrapper mb-0">
            <h6 class="form-title mb-3">DATA HADIAH</h6>
          </div>

          <div class="wrapper-detail-grid">
            <div class="detail-grid">
              <p class="mb-0 font-600">Kode Hadiah</p>
              <p class="mb-0">{{ selectedHadiah.voucherCode || '-' }}</p>
            </div>
            <div class="detail-grid">
              <p class="mb-0 font-600">Nama Nasabah</p>
              <p class="mb-0">{{ selectedHadiah.nasabahName || '-' }}</p>
            </div>
            <div class="detail-grid">
              <p class="mb-0 font-600">No Anggota</p>
              <p class="mb-0">{{ selectedHadiah.noAnggota || '-' }}</p>
            </div>
            <div class="detail-grid">
              <p class="mb-0 font-600">No. HP</p>
              <p class="mb-0">{{ selectedHadiah.noHp || '-' }}</p>
            </div>
            <div class="detail-grid">
              <p class="mb-0 font-600">Hadiah</p>
              <p class="mb-0">{{ selectedHadiah.voucherName || '-' }}</p>
            </div>
            <div class="detail-grid">
              <p class="mb-0 font-600">Jenis Identitas</p>
              <ol class="ol-no-margin">
                <li v-for="identity in selectedHadiah.nasabahIdentities" :key="identity">
                  {{ identity }}
                </li>
              </ol>
            </div>
            <div class="detail-grid">
              <p class="mb-0 font-600">Status</p>
              <p class="mb-0">
                <span
                  class="status-box-md"
                  :class="getHadiahStatusClass(selectedHadiah.status)"
                >
                  {{ getHadiahStatusLabel(selectedHadiah.status) }}
                </span>
              </p>
            </div>
            <div v-if="selectedHadiah.claimedBy" class="detail-grid">
              <p class="mb-0 font-600">Klaim Dicabang</p>
              <p class="mb-0">{{ selectedHadiah.claimedBy }}</p>
            </div>
            <div v-if="selectedHadiah.claimedAt" class="detail-grid">
              <p class="mb-0 font-600">Klaim Pada Tanggal</p>
              <p class="mb-0">
                {{ $helper.changeDateFormat(selectedHadiah.claimedAt) }}
                {{ $helper.changeDateFormatGetHour(selectedHadiah.claimedAt) }}
              </p>
            </div>
          </div>

          <b-alert
            v-if="selectedHadiah.status == STATUS_HADIAH.SUDAH_DIKLAIM"
            show
            variant="success"
            class="mt-3 mb-0"
          >
            Hadiah sudah diklaim.
          </b-alert>
          <b-alert
            v-if="selectedHadiah.status == STATUS_HADIAH.EXPIRED"
            show
            variant="danger"
            class="mt-3 mb-0"
          >
            Hadiah sudah expired.
          </b-alert>

          <KlaimHadiahSpektakulerUpload
            v-if="selectedHadiah.status == STATUS_HADIAH.BELUM_DIKLAIM"
            ref="klaimHadiahUpload"
            :hadiah-code="selectedHadiah.voucherCode"
          />
        </div>
      </transition>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">Tutup</b-button>
        <b-button
          v-if="canSubmitClaim"
          variant="pgiBtn"
          :disabled="isLoadingSubmitHadiah"
          @click="openClaimConfirm"
        >
          <b-spinner v-if="isLoadingSubmitHadiah" type="grow" small />
          Kirim
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-confirm-klaim-hadiah"
      title="Konfirmasi Klaim Hadiah Spektakuler"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      Apakah Anda yakin ingin klaim hadiah ini?

      <template v-slot:modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          :disabled="isLoadingSubmitHadiah"
          @click="cancel()"
        >
          Batal
        </b-button>
        <b-button
          variant="pgiBtn"
          :disabled="isLoadingSubmitHadiah"
          @click="onClaimHadiah"
        >
          <b-spinner v-if="isLoadingSubmitHadiah" type="grow" small />
          Kirim
        </b-button>
      </template>
    </b-modal>

  </b-col>
</template>

<script>
import CONSTANTS from '@/constants'
import KlaimHadiahSpektakulerUpload from '@/components/gadai/klaim-hadiah/KlaimHadiahSpektakulerUpload'

export default {
  name: 'klaim-hadiah-spektakuler',
  components: {
    KlaimHadiahSpektakulerUpload,
  },
  data() {
    return {
      isClaimListVisible: false,
      isLoadingSearch: false,
      isLoadingSubmitHadiah: false,
      hadiahInput: '',
      selectedHadiah: null,
      claimFilters: {
        hadiahCode: '',
        customerName: '',
        cabang: null,
      },
      appliedClaimFilters: {
        hadiahCode: '',
        customerName: '',
        cabang: null,
      },
      claimFields: [
        { key: 'voucherCode', label: 'Kode Hadiah' },
        { key: 'nasabah', label: 'Nasabah' },
        { key: 'voucherName', label: 'Hadiah' },
        { key: 'claimed', label: 'Diklaim' },
        { key: 'evidence', label: 'Bukti' },
      ],
      claimList: [],
      claimListPageOptions: [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 30, text: '30' },
        { value: 40, text: '40' },
        { value: 50, text: '50' },
      ],
      claimListState: {
        isBusy: false,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalViewText: '',
      },
    }
  },
  computed: {
    STATUS_HADIAH() {
      return CONSTANTS.VOUCHER.STATUS_PROMO_SPEKTAKULER
    },
    cabangOptions() {
      const cabang = this.getCabangOptions()
      return [
        { id: null, name: 'Semua' },
        ...cabang,
      ]
    },
    canSubmitClaim() {
      return this.selectedHadiah &&
        this.selectedHadiah.status == this.STATUS_HADIAH.BELUM_DIKLAIM
    },
  },
  methods: {
    openSearchModal() {
      this.resetSearchModalState()
      this.$bvModal.show('modal-pilih-klaim-hadiah')
    },
    resetSearchModalState() {
      this.resetUploads()
      this.hadiahInput = ''
      this.selectedHadiah = null
      this.isLoadingSearch = false
      this.isLoadingSubmitHadiah = false
    },
    toggleClaimList() {
      this.isClaimListVisible = !this.isClaimListVisible
      if (this.isClaimListVisible) {
        this.getClaimList()
      }
    },
    searchClaimList() {
      this.appliedClaimFilters = {
        ...this.claimFilters,
      }
      this.getClaimList(1)
    },
    resetClaimListFilter() {
      this.claimFilters = {
        hadiahCode: '',
        customerName: '',
        cabang: null,
      }
      this.appliedClaimFilters = {
        ...this.claimFilters,
      }
      this.getClaimList(1)
    },
    onClaimListLimitChange(newPerPage) {
      this.claimListState.perPage = newPerPage
      this.getClaimList(1)
    },
    onClaimListPageChange(newPage) {
      this.getClaimList(newPage)
    },
    getClaimList(page = 1) {
      this.claimListState.isBusy = true
      this.claimList = []
      this.claimListState.currentPage = isNaN(page) ? 1 : page

      const params = {
        page: this.claimListState.currentPage - 1,
        size: this.claimListState.perPage,
        filterCabang: this.getClaimFilterCabang(),
        filterVoucherCode: this.appliedClaimFilters.hadiahCode || '',
        filterNasabahName: this.appliedClaimFilters.customerName || '',
      }

      return this.$axios.get('voucher/spin/all-data', { params }).then(response => {
        this.claimList = response.data.data || []
        this.claimListState.totalRows = response.data.total || 0
        this.setClaimListTotalViewText()
      }).catch(error => {
        this.$helper.parseError(this, error)
      }).finally(() => {
        this.claimListState.isBusy = false
      })
    },
    getClaimFilterCabang() {
      const cabang = this.appliedClaimFilters.cabang
      return cabang && cabang.id ? cabang.id : ''
    },
    setClaimListTotalViewText() {
      if (!this.claimListState.totalRows) {
        this.claimListState.totalViewText = 'Menampilkan 0 - 0 dari 0 entri'
        return
      }

      const page = this.claimListState.currentPage - 1
      const prev = page * this.claimListState.perPage + 1
      let limit = page * this.claimListState.perPage + this.claimListState.perPage
      if (limit > this.claimListState.totalRows) limit = this.claimListState.totalRows

      this.claimListState.totalViewText = `Menampilkan ${prev} - ${limit} dari ${this.claimListState.totalRows} entri`
    },
    async searchHadiah() {
      if (!this.hadiahInput.trim()) {
        this.$helper.toastErr(this, 'Hadiah wajib diisi.')
        return
      }

      this.isLoadingSearch = true
      try {
        const response = await this.$axios.get('voucher/spin/search-code', {
          params: {
            code: this.hadiahInput.trim(),
          },
        })

        const currentCode = this.selectedHadiah && this.selectedHadiah.voucherCode
        const nextCode = this.hadiahInput.trim()

        this.selectedHadiah = this.mapSearchHadiah(response.data)
        if (currentCode !== nextCode) {
          this.resetUploads()
        }
      } catch (error) {
        this.selectedHadiah = null
        this.$helper.parseError(this, error)
      } finally {
        this.isLoadingSearch = false
      }
    },
    getHadiahStatusLabel(status) {
      const labels = {
        [CONSTANTS.VOUCHER.STATUS_PROMO_SPEKTAKULER.BELUM_DIKLAIM]: 'Belum Diklaim',
        [CONSTANTS.VOUCHER.STATUS_PROMO_SPEKTAKULER.SUDAH_DIKLAIM]: 'Sudah Diklaim',
        [CONSTANTS.VOUCHER.STATUS_PROMO_SPEKTAKULER.EXPIRED]: 'Expired',
      }

      return labels[status] || '-'
    },
    getHadiahStatusClass(status) {
      const classes = {
        [CONSTANTS.VOUCHER.STATUS_PROMO_SPEKTAKULER.BELUM_DIKLAIM]: 'status-box-warning',
        [CONSTANTS.VOUCHER.STATUS_PROMO_SPEKTAKULER.SUDAH_DIKLAIM]: 'status-box-success',
        [CONSTANTS.VOUCHER.STATUS_PROMO_SPEKTAKULER.EXPIRED]: 'status-box-danger',
      }

      return classes[status] || 'status-box-secondary'
    },
    validateUploads() {
      return this.$refs.klaimHadiahUpload &&
        this.$refs.klaimHadiahUpload.validateUploads()
    },
    openClaimConfirm() {
      if (!this.validateUploads()) return

      this.$bvModal.show('modal-confirm-klaim-hadiah')
    },
    async onClaimHadiah() {
      if (!this.validateUploads()) return

      this.isLoadingSubmitHadiah = true
      try {
        await this.$axios.post('voucher/spin/claim-voucher', this.buildClaimPayload())
        this.selectedHadiah.status = this.STATUS_HADIAH.SUDAH_DIKLAIM
        this.$helper.toastSucc(this, 'Hadiah berhasil diklaim.')
        this.$bvModal.hide('modal-confirm-klaim-hadiah')
        this.$bvModal.hide('modal-pilih-klaim-hadiah')
        this.isClaimListVisible = true
        this.getClaimList(1)
      } catch (error) {
        this.$helper.parseError(this, error)
      } finally {
        this.isLoadingSubmitHadiah = false
      }
    },
    buildClaimPayload() {
      return {
        code: this.selectedHadiah.voucherCode,
        cabangId: Number(this.$helper.getCabangId()),
        urlPhoto: this.getUploadedUrl('photo'),
        urlVideo: this.getUploadedUrl('testimonialVideo'),
        urlReceipt: this.getUploadedUrl('receipt'),
      }
    },
    getUploadedUrl(key) {
      return this.$refs.klaimHadiahUpload
        ? this.$refs.klaimHadiahUpload.getUploadedUrl(key)
        : null
    },
    resetUploads() {
      if (this.$refs.klaimHadiahUpload) {
        this.$refs.klaimHadiahUpload.resetUploads()
      }
    },
    onReset() {
      this.selectedHadiah = null
      this.resetUploads()
      this.$emit('selection-change', false)
    },
    getCabangOptions() {
      try {
        const cabang = JSON.parse(localStorage.getItem('cabang') || '[]')
        if (Array.isArray(cabang) && cabang.length) return cabang
      } catch (e) {
        return []
      }

      return [
        { id: 3, name: 'Cabang A' },
        { id: 4, name: 'Cabang B' },
      ]
    },
    mapSearchHadiah(data) {
      return {
        voucherCode: this.hadiahInput.trim(),
        noAnggota: data.noAnggota,
        nasabahName: data.nasabahName,
        noHp: data.noHp,
        voucherName: data.voucherName,
        status: data.status,
        claimedBy: data.claimedBy,
        claimedAt: data.claimedAt,
        nasabahIdentities: Array.isArray(data.nasabahIdentities)
          ? data.nasabahIdentities
          : [],
      }
    },
  },
}
</script>

<style scoped>
.wrapper-detail-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.detail-grid {
  display: grid;
  grid-template-columns: 30% 70%;
  gap: 4px 16px;
}

.ol-no-margin {
  margin: 0;
  padding-inline: 15px;
}

.evidence-buttons {
  gap: 6px;
}

.evidence-buttons .btn {
  white-space: nowrap;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.35s, transform 0.35s;
}

.fade-slide-enter {
  opacity: 0;
  transform: translateY(16px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

@media (max-width: 576px) {
  .detail-grid {
    grid-template-columns: 100%;
  }
}
</style>
